import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    CurrentHeadIndex:[JSON.parse(localStorage.getItem("index"))] ||0,
    UrlList:['/home','/product','/solution','/support','/about'],
    JoinData:{},
    LoginStatus: [JSON.parse(localStorage.getItem("status"))]||false,
  },
  mutations: {
    GetCurrentIndex(state,payload){
      state.CurrentHeadIndex=payload
      localStorage.setItem('index',JSON.stringify(payload))
    },
    GetJoinData(state,payload){
      state.JoinData=payload
    },
    GetLoginStatus(state){
      state.LoginStatus=true
      localStorage.setItem('status',JSON.stringify(true))
    }
  },
  actions: {
  },
  modules: {
  }
})
